import React from 'react';

const Dot = () => <span className="text-secondary">&nbsp;·&nbsp;</span>;

export default Dot;
